import { EMPTY_FUNCTION } from '../../../constants/common'

import {
  getGretaAIChatStripNotice,
  getGretaAIChatStripNoticeContent,
} from './GretaAIChatStripNotice.utils'

function GretaAIChatStripNotice({
  isLimitReached = false,
  isLocked = false,
  isSourceOutage = false,
  isSourceRevoked = false,
  onRetry = EMPTY_FUNCTION,
}) {
  const notice = getGretaAIChatStripNotice({
    isLimitReached,
    isLocked,
    isSourceOutage,
    isSourceRevoked,
  })

  return getGretaAIChatStripNoticeContent({ notice, onRetry })
}

export default GretaAIChatStripNotice
